module.exports = __webpack_public_path__ + "static/media/bus.273952e7.png";